import type { TabProps } from '@mui/material/Tab';
import Tab from '@mui/material/Tab';
import React from 'react';

const IconTab: React.FC<Omit<TabProps, 'sx'>> = props => (
    <Tab iconPosition="start" sx={{ minHeight: 48 }} {...props} />
);

export default IconTab;
